// extracted by mini-css-extract-plugin
export var carousel = "responsive-carousel-module--carousel--d6f08";